module.exports = __webpack_public_path__ + "img/analytics.05841640.svg";